import { render, staticRenderFns } from "./autoAssign.vue?vue&type=template&id=54dd76ee&scoped=true&"
import script from "./autoAssign.vue?vue&type=script&lang=js&"
export * from "./autoAssign.vue?vue&type=script&lang=js&"
import style0 from "./autoAssign.vue?vue&type=style&index=0&id=54dd76ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dd76ee",
  null
  
)

export default component.exports